import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { makeStyles } from 'tss-react/mui'
import { Actions_Organizations } from 'redux/modules/organizations/Actions'

export const useOrganizationsFilter = () => {
  const { t } = useTranslation(I18nModal.organizationsFilter)
  const dispatch = useDispatch()
  const { classes } = useStyles()

  const data = useSelector(({ organizations }: TState) => organizations.data)
  const isLoading = useSelector(({ organizations }: TState) => organizations.isLoading)
  const initialCheckedIds = useSelector(({ organizations }: TState) => organizations.selectedOrganizationIds)

  const [checkedIds, setCheckedIds] = useState(initialCheckedIds)

  const handleToggle = (value: number) => () => {
    const currentIndex = checkedIds.indexOf(value)
    const newCheckedIds = [...checkedIds]

    if (currentIndex === -1) {
      newCheckedIds.push(value)
    } else {
      newCheckedIds.splice(currentIndex, 1)
    }

    setCheckedIds(newCheckedIds)
  }

  const isSelectAll = checkedIds.length === data?.organizations.length

  const handleToogleAll = () => {
    if (isSelectAll) {
      setCheckedIds([])
    } else {
      const allIds = data?.organizations.map(({ id }) => id) || []
      setCheckedIds(allIds)
    }
  }

  const onSubmit = () => {
    dispatch(Actions_Organizations.store.changeSelectedOrganizationIds(checkedIds))
    dispatch(Actions_Modals.store.hideModal())
  }

  const closeModal = () => {
    dispatch(Actions_Modals.store.hideModal())
  }

  return {
    t,
    classes,
    closeModal,
    isLoading,
    onSubmit,
    data: data?.organizations || [],
    checkedIds,
    isSelectAll,
    handleToggle,
    handleToogleAll,
  }
}

const useStyles = makeStyles()((theme) => ({
  card: {
    width: 375,
    overflowY: 'auto',
    maxHeight: '100%',
  },
  list: {
    overflow: 'auto',
    maxHeight: 300,
  },
  listItemText: {
    // ...theme.typography.body1, TODO:
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    color: theme.typography.body1.color,
  },
  cancel: {
    margin: '0.875em 0',
  },
}))
